// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* FacultyHome.css - Empty to use global Home.css themes */
.faculty-special-badge {
    background: var(--accent-color);
    color: var(--background);
    padding: 2px 8px;
    border-radius: 4px;
    font-size: 0.75rem;
    font-weight: 800;
    text-transform: uppercase;
    margin-left: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/pages/faculty/FacultyHome.css"],"names":[],"mappings":"AAAA,0DAA0D;AAC1D;IACI,+BAA+B;IAC/B,wBAAwB;IACxB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;AACvB","sourcesContent":["/* FacultyHome.css - Empty to use global Home.css themes */\n.faculty-special-badge {\n    background: var(--accent-color);\n    color: var(--background);\n    padding: 2px 8px;\n    border-radius: 4px;\n    font-size: 0.75rem;\n    font-weight: 800;\n    text-transform: uppercase;\n    margin-left: 0.5rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
